<div class="card my-4">
    <div class="card-body">


            <div class="row">
                <div class="col-12 text-center">
                    <h5>Cobertura/Prêmio</h5>
                </div>
            </div>                
            
            <div class="row mt-4">
    
                <div class="col-12">
                    
                    <div class="row">
                        <div class="col-6">
                            <strong>Morte</strong>                                                        
                        </div>                       
                        <div class="col-6 text-right">                            
                            <div class="ml-4 d-inline custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="cobMorte" [disabled]="loading || idcDisCobMorte" [(ngModel)]="idcCobMorte" (change)="onCoberturaChange(); calcularPremioTotal()">
                                <label class="custom-control-label" for="cobMorte"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <input class="d-inline" [(ngModel)]="coberturaMorte" (change)="calcularPremioMorte()" [disabled]="loading" name="coberturaMorte" [max]="coberturaMorteDisponivel" min="20000" name="rentability" step="1000" type="range" style="width: 100%;" />
                        </div>                    
                    </div>

                    <div class="row" style="margin-top: -10px;">
                        <div class="col-6 pt-0 text-muted">
                            <small>R$ 20.000</small> 
                        </div>
                        <div class="col-6 pt-0 text-right text-muted">
                            <small>{{coberturaMorteDisponivel| currency:'R$'}}</small> 
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col-12 p-0 text-center">
                            <strong>{{coberturaMorte| currency:'R$'}}</strong> / <span>{{premioMorte| currency:'R$'}} mês</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row mt-5">
                <div class="col-12">

                    <div class="row">
                        <div class="col-6">
                            <strong>Invalidez</strong>                                                        
                        </div>                       
                        <div class="col-6 text-right">                            
                            <div class="ml-4 d-inline custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="cobInvalidez" [disabled]="loading || idcDisCobInvalidez" [(ngModel)]="idcCobInvalidez" (change)="onCoberturaChange(); calcularPremioTotal()">
                                <label class="custom-control-label" for="cobInvalidez"></label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <input class="d-inline" [(ngModel)]="coberturaInvalidez" (change)="calcularPremioInvalidez()" [disabled]="loading" name="coberturaInvalidez" [max]="coberturaInvalidezDisponivel" min="20000" name="rentability" step="1000" type="range" style="width: 100%;" />
                        </div>
                    </div>

                    <div class="row" style="margin-top: -10px;">
                        <div class="col-6 pt-0 text-muted">
                            <small>R$ 20.000</small> 
                        </div>
                        <div class="col-6 pt-0 text-right text-muted">
                            <small>{{coberturaInvalidezDisponivel| currency:'R$'}}</small> 
                        </div>
                    </div>
                    
                    <div class="row mt-1">
                        <div class="col-12 p-0 text-center">
                            <strong>{{coberturaInvalidez| currency:'R$'}}</strong> / <span>{{premioInvalidez| currency:'R$'}} mês</span>
                        </div>
                    </div>

                </div>
            </div>     

            <div class="row mt-4">
                <div class="col-12 text-center">
                    <h5 class="premio-total"><span style="font-weight: normal;">Prêmio Total:</span> {{premioTotal| currency:'R$'}}/Mês</h5>
                </div>
            </div>

    </div>
</div>